/* eslint react/prop-types: 0 */
import React from 'react';
import { formatMoney } from '../../utils/money';
import { CourseLink, JockeyLink } from '../../shared/links/ProfileLink';
import Abbr from '../../shared/Abbr';
import { zeroToDash } from '../../utils/number';
import { sortByDate } from '../../utils/date';
import { goingSortFn } from '../../utils/going';

export const sharedColumns = [
    {
        key: 'startsNumber',
        header: 'runs',
    },
    {
        key: 'place1stNumber',
        header: 'wins',
    },
    {
        key: 'place2ndNumber',
        header: '2nd',
    },
    {
        key: 'place3rdNumber',
        header: '3rd',
    },
    {
        key: 'netWinPrize',
        header: 'win prize money',
        cell: ({ netWinPrize }) => formatMoney(netWinPrize),
    },
    {
        key: 'netTotalPrize',
        header: 'total prize money',
        cell: ({ netTotalPrize }) => formatMoney(netTotalPrize),
    },
    {
        key: 'bestRpTopspeed',
        header: 'best ts',
        cell: zeroToDash('bestRpTopspeed'),
    },
    {
        key: 'bestRpPostmark',
        header: 'best rpr',
        cell: zeroToDash('bestRpPostmark'),
    },
];


export const firstColumns = {
    course: {
        key: 'courseStyleName',
        header: 'course',
        cell: ({ courseStyleName, courseUid, courseComment }) => (
            <CourseLink
                courseStyleName={courseStyleName}
                courseUid={courseUid}
                title={courseComment}
            />
        ),
        sortFn: 'alphabetic',
    },
    distance: {
        key: 'distance',
        sortFn: (a, b) => a.distanceYard - b.distanceYard,
    },
    jockey: {
        key: 'jockeyStyleName',
        header: 'jockey',
        cell: ({ jockeyStyleName, jockeyShortName, jockeyUid }) => (
            <JockeyLink
                jockeyStyleName={jockeyStyleName}
                jockeyUid={jockeyUid}
            >
                <Abbr title={jockeyStyleName} breakpoint="fromMedium">
                    {jockeyShortName}
                </Abbr>
            </JockeyLink>
        ),
        sortFn: 'byLastName',
    },
    going: {
        key: 'going',
        sortFn: goingSortFn,
    },
    month: {
        key: 'monthName',
        header: 'month',
        sortFn: sortByDate('dateStr', true),
    },
    class: {
        key: 'class',
        header: 'class',
        cell: ({ class: cls }) => {
            const match = cls.match(/^Cl(\d+)$/);
            return match ? `Class ${match[1]}` : cls;
        },
        sortFn: 'alphabetic',
    },
};



// WEBPACK FOOTER //
// ./src/js/horse/stats/columns.jsx